export const masterTableColumns = [
  {
    label: "规则名称",
    value: "name"
  },
  {
    label: "规则描述",
    value: "description"
  },
  {
    label: "工作表",
    value: "sheetName"
  },
  {
    label: "同步类型",
    value: "exportStr"
  },
  {
    label: "状态",
    value: "enable"
  },
  {
    label: "创建人",
    value: "creator.name"
  },
  {
    label: "创建时间",
    value: "createAt"
  }
]

export const availableMasterTableColumns = [
  {
    label: "规则名称",
    value: "name"
  },
  {
    label: "规则描述",
    value: "description",
    showOverflowTooltip: true
  },
  {
    label: "互联企业",
    value: "companyName",
    showOverflowTooltip: true
  },
  {
    label: "工作表",
    value: "sheetName"
  },
  {
    label: "同步类型",
    value: "exportStr"
  }
]

export const slaveTableColumns = [
  {
    label: "规则名称",
    value: "ruleMaster.name"
  },
  {
    label: "规则描述",
    value: "ruleMaster.description"
  },
  {
    label: "互联企业",
    value: "ruleMaster.companyName"
  },
  {
    label: "工作表",
    value: "sheetName"
  },
  {
    label: "同步类型",
    value: "exportStr"
  },
  {
    label: "状态",
    value: "enable"
  }
]

export const logTableColumns = [
  {
    label: "规则名称",
    value: "ruleName",
    width: "150px",
    align: "center"
  },
  {
    label: "工作表",
    value: "sheetName",
    width: "150px",
    align: "center"
  },
  {
    label: "状态",
    value: "status",
    width: "120px",
    align: "center"
  },
  {
    label: "同步企业",
    value: "targetCompanyName",
    width: "120px",
    align: "center"
  },
  {
    label: "同步总数（条）",
    value: "total",
    width: "150px",
    align: "center"
  },
  {
    label: "同步未执行数（条）",
    value: "leftCount",
    width: "150px",
    align: "center"
  },
  {
    label: "失败数据",
    value: "dataTitle",
    width: "150px",
    align: "center"
  },
  {
    label: "失败原因",
    value: "failRes",
    width: "150px",
    align: "center"
  },
  {
    label: "流程触发人",
    value: "creator.name",
    width: "150px",
    align: "center"
  },
  {
    label: "同步开始时间",
    value: "startAt",
    width: "156px",
    align: "center"
  },
  {
    label: "同步完成时间",
    value: "endAt",
    width: "156px",
    align: "center"
  }
]
